<template>
  <node :title="config.name" :show-error="showError" :content="content" :error-info="errorInfo" :config="config"
        @selected="$emit('selected')" @delNode="$emit('delNode')" @insertNode="type => $emit('insertNode', type)"
        placeholder="请设置办理人" :header-bgc="headerBgc" header-icon="el-icon-s-claim"/>
</template>

<script>
import Node from './Node'
import { groupAllList } from "@/api/ops/group";

export default {
  name: "TaskNode",
  props:{
    config:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {Node},
  data() {
    return {
      showError: false,
      errorInfo: '',
      headerBgc: '#E6B039',
      groupOptions: []
    }
  },
  computed:{
    formItems() {
      return this.$store.state.design.formItems
    },
    content(){
      const config = this.config.props
      switch (config.assignedType){
        case "ASSIGN_USER":
          if (config.assignedUser.length > 0){
            let texts = []
            config.assignedUser.forEach(org => texts.push(org.name))
            return String(texts).replaceAll(',', '、')
          }else {
            return '请指定办理人'
          }
        case "SELF":
          return '发起人自己'
        case "SELF_SELECT":
          return config.selfSelect.multiple ? '发起人自选多人':'发起人自选一人'
        case "LEADER_TOP":
          return '多级主管依次办理'
        case "LEADER":
        case "LEADER_CROSS":
          return config.leader.level > 1 ? '发起人的第 ' + config.leader.level + ' 级主管' : '发起人的直接主管'
        case "FORM_USER":
          if (!config.formUser || config.formUser === ''){
            return '表单内联系人（未选择）'
          }else {
            let text = this.getFormItemById(this.formItems, config.formUser)
            if (text && text.title){
              return `表单（${text.title}）内的人员`
            }else {
              return '该表单已被移除😥'
            }
          }
        case "ROLE":
          if (config.role.length > 0){
            return String((config.role || []).map(v => v.name)).replaceAll(',', '、')
          }else {
            return '指定角色（未设置）'
          }
        case "POST":
          if (config.post.length > 0){
            return String((config.post || []).map(v => v.name)).replaceAll(',', '、')
          }else {
            return '指定岗位（未设置）'
          }
        case 'POST_CROSS':
          if (config.postCross.length > 0) {
            return `公共岗位 [${String(config.postCross.map(r => r.name)).replaceAll(',', '、')}] `
          } else {
            return '公共岗位（未设置）'
          }
        case "ASSIGN_GROUP":
          if (this.$isNotEmpty(config.assignedGroup)) {
            return `组群 [${String(this.groupOptions.find(item => item.groupId === config.assignedGroup)?.groupName)}] `
          } else {
            return '指定组群（未设置）'
          }
        case "SUB_FORM_POST":
          if (this.$isNotEmpty(config.fieldId)) {
            return `主流程表单（${config.fieldId}）内的权限`
          } else {
            return '指定表单id（未设置）'
          }
        case "ROUTING":
          if (this.$isNotEmpty(config.routing.type)) {
            if (config.routing.type == 1) return config.routing.post.length > 0 ? `执行对象（岗位：${config.routing.post[0].name}）` : `执行对象（岗位：未设置）`
            if (config.routing.type == 2) return config.routing.role.length > 0 ? `执行对象（角色：${config.routing.role[0].name}）` : `执行对象（角色：未设置）`
            if (config.routing.type == 3) return config.routing.assignedGroup != '' ? `执行对象（组群：${String(this.groupOptions.find(item => item.groupId === config.routing.assignedGroup)?.groupName)}）` : `执行对象（组群：未设置）`
          } else {
            return '执行对象（未设置）'
          }
        case "OPS_USER": 
          return '运维人员'  
        case 'FORM_DEPT':
          if (!config.formDept || config.formDept === '') {
            return '表单内部门的主管（未选择）'
          } else {
            const text = this.getFormItemById(this.formItems, config.formDept)
            if (text && text.title) {
              return `表单（${text.title}）内的部门主管`
            } else {
              return '该表单项已被移除😥' + "<span style='display: none;'>undefined</span>"
            }
          }
        case "CHECK_ROUTING":
          if (this.$isNotEmpty(config.check.fieldId)) {
            return `由关联数据项内签到人员审批`
          } else {
            return '关联数据项（未设置）'
          }
        default: return '未知设置项😥'
      }
    }
  },
  created() {
    this.getGroupOptions()
  },
  mounted() {
    const arr = this.$store.state.processData.progress
    if (arr != undefined) {
      if (!arr.find(item => item.nodeId == this.config.id)) this.headerBgc = '#909399'
      for (let i = 0; i < arr.length; i++) {
        if(arr[i].nodeId == this.config.id){
          if (arr[i].finishTime && arr[i].result == 'agree') this.headerBgc = '#067b50'
          else if (arr[i].finishTime && arr[i].result == null) this.headerBgc = '#909399'
          else if (arr[i].result == 'refuse') this.headerBgc = '#F56C6C'
          else if (!arr[i].finishTime) this.headerBgc = '#409EFF' 
        }
      }
    }
  },
  methods: {
    getGroupOptions() {
      groupAllList().then(res => {
        this.groupOptions = res.data.data
      })
    },
    getFormItemById(items, id) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].name === 'SpanLayout') {
          const result = this.getFormItemById(items[i].props.items, id)
          if (result) {
            return result
          }
        } else if (items[i].id === id) {
          return items[i]
        }
      }
      return null
    },
    //校验数据配置的合法性
    validate(err){
      try {
        return this.showError = !this[`validate_${this.config.props.assignedType}`](err)
      } catch (e) {
        return true;
      }
    },
    validate_ASSIGN_USER(err){
      if(this.config.props.assignedUser.length > 0){
        return true;
      }else {
        this.errorInfo = '请指定办理人员'
        err.push(`${this.config.name} 未指定办理人员`)
        return false
      }
    },
    validate_SELF_SELECT(err){
      return true;
    },
    validate_LEADER_TOP(err){
      return true;
    },
    validate_LEADER(err){
      return true;
    },
    validate_ROLE(err){
      if (this.config.props.role.length <= 0){
        this.errorInfo = '请指定负责办理的系统角色'
        err.push(`${this.config.name} 未指定办理角色`)
        return false
      }
      return true;
    },
    validate_SELF(err){
      return true;
    },
    validate_FORM_USER(err){
     if (this.config.props.formUser === ''){
       this.errorInfo = '请指定表单中的人员组件'
       err.push(`${this.config.name} 办理人为表单中人员，但未指定`)
       return false
     }
      return true;
    },
    validate_REFUSE(err){
      return true;
    },
    validate_ROUTING(err) {
      if (this.$isNotEmpty(this.config.props.routing) && this.config.props.routing.type != null) {
        if (this.config.props.routing.type == 1 && this.config.props.routing.post.length == 0) {
          this.errorInfo = '请选择岗位'
          err.push(`${this.config.name} 未选择岗位`)
          return false
        }
        if (this.config.props.routing.type == 2 && this.config.props.routing.role.length == 0) {
          this.errorInfo = '请选择角色'
          err.push(`${this.config.name} 未选择角色`)
          return false
        }
        if (this.config.props.routing.type == 3 && this.config.props.routing.assignedGroup == '') {
          this.errorInfo = '请选择组群'
          err.push(`${this.config.name} 未选择组群`)
          return false
        }
        if (this.config.props.routing.fieldId == '') {
          this.errorInfo = '请指定关联商铺'
          err.push(`${this.config.name} 未指定关联商铺`)
          return false
        }
        // 关联商铺的字段是从其他流程引用的,不存在于当前表单
        const text = this.getFormItemById(this.formItems, this.config.props.routing.fieldId)
        if (text == null) {
          this.errorInfo = '关联商铺不存在'
          err.push(`${this.config.name} 关联商铺不存在`)
          return false
        }
        return true
      } else {
        this.errorInfo = '请选择执行对象'
        err.push(`${this.config.name} 未指定执行对象`)
        return false
      }
    },
    validate_CHECK_ROUTING(err) {
      if (this.$isNotEmpty(this.config.props.check) && this.$isNotEmpty(this.config.props.check.fieldId)) {
        return true
      } else {
        this.errorInfo = '请选择表单关联项'
        err.push(`${this.config.name} 未指定表单关联项`)
        return false
      }
    },
  }
}
</script>

<style scoped>

</style>
